module.exports = __webpack_public_path__ + "static/media/AINIT.e9db3c75.png";